import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMe } from '../App';
import { Icon } from '../icons';

// Odoo-style distinct colour per app
const APP_COLORS = {
  inventory_app:'#3E7C6B', purchase_app:'#2C5F8A', assembly_app:'#925F88',
  masters:       '#2C5F8A', // steel blue
  configuration: '#5A6472', // slate grey
  marketing:     '#1F3A6B', // navy
  store_app:     '#3E7C6B', // muted teal-green
  store:         '#3E7C6B',
  warranty:      '#8A6D3B', // bronze
};
export function appColor(key) { return APP_COLORS[key] || '#714B67'; }

export default function HomeGrid() {
  const me = useMe();
  const nav = useNavigate();
  return (
    <div className="o-home">
      <div className="o-home-grid">
        {me.modules.map((app) => {
          const first = app.children[0];
          return (
            <button key={app.key} className="o-app-tile" onClick={() => first && nav('/m/' + first.key)}>
              <span className="o-app-ic" style={{ background: appColor(app.key), boxShadow: `0 4px 12px ${appColor(app.key)}55` }}>
                <Icon name={app.icon} />
              </span>
              <span className="o-app-label">{app.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
